import TyumenIcon from './component'

export default TyumenIcon
